import { getCorporateRateMatrix } from '../../store/generalSetting/GSAction'
export const totalPagesExp = '{total_pages_count_string}'

export const Rs = '₹'
export const AgentID = '45246'
export const intCurrencyID = 1
export const dateFormaat = 'HH:MM, DDD, DD-MMM-YYYY' //24 hours date format
export const STA_COVER_C_ID = 1639
export const STA_PACKET_C_ID = 1638
export const STA_HOUSEHOLD_C_ID = 9163
export const STA_PARCEL_C_ID = 1637
export const STA_TWO_WHEELER_C_ID = 9430
export const API_CACHE_DURATION = 24 * 60 * 60 * 1000
export const LIMIT_FOR_NON_EWAYBILLL_BOOKING = 50000
export const STA_DOC_CHARGE_TABLE = [
  { from: 0, to: 300, charge: 30 },
  { from: 301, to: 500, charge: 50 },
  { from: 501, to: Infinity, charge: 100 },
]

export const mailRegex = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/
// /^[a-zA-Z0-9.!#$%&*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/; // taken from RFC // but not .com .net other domain checks
export const ccRegex = /^(\+?\d{1,3}|\d{1,4})$/
export const nameRegex = /^[a-zA-z]+[a-zA-z0-9_]\*(\\(.*?\\))\*$/
export const gstRegex = /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9a-zA-Z]{1}$/
// export const aadharRegex = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$`/ ///^[2-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$`/ for added space
export const aadharRegex = /[2-9]{1}[0-9]{11}/
export const panCardRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/
//export const driverLicenseRegex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/
export const driverLicenseRegex = /^[A-Z]{2}[0-9A-Z]+$/
export const WEIGHT_BILLED = 1
export const UNIT_BILLED = 2
export const NO_RIGHTS = 0
export const LIMITED_RIGHTS = 1
export const UNLIMITED_RIGHTS = 2
export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export const monthNameFull = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
export const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

//const baseUrl = 'http://stagingcargoapi.bookbustickets.com'
// const baseUrl = 'https://cargoapi.mavenconnect.tech'
let baseUrl = ''
if (window.location.origin.includes('mavenconnect.tech')) {
  baseUrl = 'https://stagecargoapi.mavenconnect.tech'
} else if (window.location.origin.includes('mavenconnect.biz')) {
  baseUrl = 'https://cargoapi.mavenconnect.tech'
}

export const getBaseGSTInvoiceURL = (intbookingid, EventType, companyid) => {
  let baseUrlForGSTInvoice = `https://cargo.mavenconnect.tech/GSTInvoice?intbookingid=${intbookingid}&EventType=${EventType}&companyid=${companyid}`
  if (window.location.origin.includes('mavenconnect.tech')) {
    baseUrlForGSTInvoice = `https://cargo.mavenconnect.tech/GSTInvoice?intbookingid=${intbookingid}&EventType=${EventType}&companyid=${companyid}`
  } else if (window.location.origin.includes('mavenconnect.biz')) {
    baseUrlForGSTInvoice = `https://cargo.mavenconnect.biz/GSTInvoice?intbookingid=${intbookingid}&EventType=${EventType}&companyid=${companyid}`
  }
  return baseUrlForGSTInvoice
}

export const urls = {
  //login api
  login: baseUrl + `/api/Login`,
  ResetPassword: baseUrl + `/api/Common/ResetPassword`,
  // common
  getCargoSetting: baseUrl + `/api/GetCargoSetting`,
  getOwnParentCompany: baseUrl + `/api/Common/GetOwnParentCompany?`,
  getRoleRights: baseUrl + `/api/Common/CargoRoleRightsConfigListAll?`,
  getRoleRightsSetting: baseUrl + `/api/UserRoleRights/CargoRoleRightsConfigListAll?`,
  getServerTime: baseUrl + `/api/Common/GetServerTime?`,
  getVehilceList: baseUrl + `/api/GetVehicleNo`,
  getDriverList: baseUrl + `/api/Common/DriverConductorListAll`,
  driverConductorInsertUpdate: baseUrl + `/api/Common/DriverConductorInsertUpdate`,
  getPolicyRights: baseUrl + `/api/GeneralSettings/BranchPaymentTypeConfigDetails?`,
  getBranchPaymentTypeConfigDetails: baseUrl + `/api/GeneralSettings/BranchPaymentTypeConfigDetails?`,
  GetCountryCode: baseUrl + `/api/Common/GetCountryCode`,
  // booking
  bookingCommonConfig: baseUrl + `/api/Common/GetCargoBookingCommonConfig?`,
  gstConfig: baseUrl + `/api/Report/CargoGetGstInvoiceConfig?`,
  getCityList: baseUrl + `/api/Common/CargoCompanyCitiesListAll?`,
  getdispatchcheckinCities: baseUrl + `/api/Common/GetdispatchcheckinCities?`,
  getCargoCitiesWithPaymentTypeRights: baseUrl + `/api/Common/CargoCitiesWithPaymentTypeRights?`,
  getBranchConfigOrEwbillinfo: baseUrl + `/api/Common/BranchesListAll`,
  getEWBConfig_InsertUpdate: baseUrl + `/api/EWBConfig_InsertUpdate`,
  cargoCompanySettingsInsertUpdate: baseUrl + `/api/CargoCompanySettingsInsertUpdate`,
  cargoGetBranchBkgPermission: baseUrl + `/api/Common/CargoGetBranchBkgPermission?`,
  getBranchList: baseUrl + `/api/Common/BranchesListAllCargoShared?`,
  BranchesListCargoSharedAll: baseUrl + `/api/Common/BranchesListCargoSharedAll`,
  getPartyList: baseUrl + `/api/GetPartyMaster?`,
  bookingsLoad: baseUrl + `/api/Common/BookingsLoad?`,
  focApproverList: baseUrl + `/api/Common/CargoGetFoCApprovalAuthoritiesDetails?`,
  cargoFOCSMSOtpDetailsV2: baseUrl + `/api/Common/CargoFOCSMSOtpDetailsV2`,
  branchCreditLimit: baseUrl + `/api/Common/CargoBranchCreditLimit?`,
  getEWBInfo: baseUrl + `/api/GetEWBInfo`,
  getLastLR: baseUrl + `/api/Common/GetLastLR?`,
  getNameAndAddress: baseUrl + `/api/Common/GetNameAndAddress?`,
  getMOFPayment: baseUrl + `/api/GetCashMode/GetModeOfPayments?`,
  bankAccountDetail: baseUrl + `/api/GetCashMode/GetBankAccountDetails?`,
  branchAndPartyRecharge: baseUrl + `/api/BranchRechargeRequest/Post`,
  getDQRDetails: baseUrl + `/api/BranchRechargeRequest/GetDQRAccountDetails?`,
  getQRDetailsInsert: baseUrl + `/api/BranchRechargeRequest/QRPaymentDetailsInsert`,
  getBranchRechargeConfm: baseUrl + `/api/BranchRechargesInsertConfirm`,
  BranchRechargesInsertConfirmUpdate: baseUrl + `/api/BranchRechargesInsertConfirm`,
  BranchRechargesInsertConfirm: baseUrl + `/api/BranchRechargesInsertConfirm?`,
  getBranchRecahrgeRjct: baseUrl + `/api/BranchRechargesReject`,
  BranchRechargesReject: baseUrl + `/api/BranchRechargesReject?`,
  BranchRechargesRejectUpdate: baseUrl + `/api/BranchRechargesReject`,

  // StickerPrinterOrBilltyPrinter: baseUrl + `/Service.svc/APIMicrositeBusTiming`,
  getConsignmentSubTypes: baseUrl + `/api/GetConsignmentSubTypes`,
  getGSBookingConsType: baseUrl + `/api/GetConsignmentSubTypes`,
  getFocApprConsType: baseUrl + `/api/GetConsignmentSubTypes?`,

  getMethodOfPacking: baseUrl + `/api/Common/GetMethodOfPacking?`,
  getMopTblData: baseUrl + `/api/Common/GetMethodOfPacking?`,
  getIDProofList: baseUrl + `/api/GetIDProofMaster`,
  cargoGetRateForConsignment: baseUrl + `/api/Common/CargoGetRateForConsignment`,
  getAdditionalCharges: baseUrl + `/api/GetAdditionalCharges`, //delivery cartage //roleRights gives hamali
  getDocumentCharges: baseUrl + `/api/GetDocumentCharges`, //document chage
  getCargoRateInquiry: baseUrl + `/api/Common/GetCargoRateInquiry?`, //for if cartage enabled.
  //pricing Inquiry
  GetCargoRateInquiryV3: baseUrl + `/api/Common/GetCargoRateInquiryV3?`,
  pickupAndDropoffchargeList: baseUrl + `/api/Common/CargoPickupAndDropoffChargesListAll`, //for pickup dropoff charge
  bookingSave: baseUrl + `/api/CargoBookingWebInsert`,
  printCargoBooking: baseUrl + `/api/Print/CargoBookingDetailsToPrint`,
  cancelBooking: baseUrl + `/api/Refund/RefundBooking`,
  //for map modal apis
  getNearStateList: baseUrl + `/api/GeneralSettings/GetCargoStateList?`,
  getNearCityList: baseUrl + `/api/GeneralSettings/GetCargoCityList?`,
  getNearBranchList: baseUrl + `/api/GeneralSettings/GetNeartestBranches?`,

  //Dispatch
  luggageToDispatch: baseUrl + `/api/GetLuggageToDispatchV2`,
  GetMultipleBranchLuggageToDispatch: baseUrl + `/api/GetMultipleBranchLuggageToDispatch`,
  insertDispatch: baseUrl + `/api/DispatchInsertV2`,
  insertDispatchAllV2: baseUrl + `/api/DispatchInsertAllV2`,
  crossingCities: baseUrl + `/api/Common/GetCargoCrossingCities`,
  crossingBranches: baseUrl + `/api/Common/GetCargoCrossingBranches`,
  dispatchDestinationBranchList: baseUrl + `/api/GetDestinationBranch`,
  getDispatchedLuggage: baseUrl + `/api/Common/GetDispatched?`,
  editDispatch: baseUrl + `/api/Common/GetLuggageToEditDispatch?`,
  updateDispatch: baseUrl + `/api/Common/UpdateDispatch`,
  cancelDIspatch: baseUrl + `/api/Common/CancelDispatchInsertUpdate`,
  checkinReport: baseUrl + `/api/Report/GetLuggageToDispatchCheckingReport?`,
  dispatchMemo: baseUrl + `/api/Report/GetDispatchMemoData?`,
  busAndCargoTripMaping: baseUrl + `/api/Common/GetBusAndCargoTripMaping?`,
  //delivery
  getLRList: baseUrl + `/api/GetLRList`,
  getReceiveLrList: baseUrl + `/api/GetLRList`,
  getLuggageForDelivery: baseUrl + `/api/GetLuggageForDelivery`,
  getBookingValidation: baseUrl + `/api/QRPayment/BookingValidation`,
  getDeliveryValidation: baseUrl + `/api/QRPayment/DeliveryValidation`,
  GetUnutilisedQrPaymentList: baseUrl + `/api/QRPayment/GetUnutilisedQrPaymentList?`,
  luggageSendOTPV2: baseUrl + `/api/Common/LuggageSendOTPV2`,
  getDeliveryOTPV2: baseUrl + '/api/GeneralSettings/GetDeliveryOTPV2?',

  deliveryWebInsert: baseUrl + `/api/DeliveryWebInsert`,
  cencelDelivery: baseUrl + `/api/DeliveryCancel`,
  printDelivery: baseUrl + `/api/Print/CargoDeliveryDetailsToPrint`,
  //other URLS
  searchTaxPayer: `https://services.gst.gov.in/services/searchtp`,

  //printing
  cargoTicketFormat: baseUrl + `/api/Print/CargoTicketFormatListAll`,

  //url for branch transfer

  getListData: baseUrl + `/api/GetLuggageForBranchTransferV2`,
  getBranchTransfer: baseUrl + `/api/BranchTransferInsert`,
  getBranchTransferV2: baseUrl + `/api/BranchTransferV2Insert`,

  getCancelTransferList: baseUrl + `/api/GetBranchTransfered?`,
  getCancelTransfer: baseUrl + `/api/CancelBranchTransfer`,
  getPrintMemo: baseUrl + `/api/Report/GetBranchTransferMemoReport?`,
  getCheckingReport: baseUrl + `/api/Report/GetLuggageToBranchTransferCheckingReport?`,
  getBranchTransferUpdate: baseUrl + `/api/BranchTransferEdit`,

  //url for branch transfer receive
  getDispatchBranches: baseUrl + `/api/Common/CargoGetBranchsForBranchTransactions?`,
  getShowlistData: baseUrl + `/api/GetLugageforBranchReceiveV2`,
  getReceive: baseUrl + `/api/BranchReceiveInsertUpdate`,
  getReceiveV2: baseUrl + `/api/BranchReceiveInsertAllV2Update`,
  getReceiveItemList: baseUrl + `/api/Report/GetBranchRecieveItemList?`,

  //url for Receive
  getReceiveDispatchCities: baseUrl + `/api/GetDispatchedCities`,
  getReceiveDispatchCitiesBranches: baseUrl + `/api/Common/GetDispatchedCitiesBranches`,
  getReceiveDispatchChallanNo: baseUrl + `/api/GetDispatchedVoucher`,
  getReceiveShowlistData: baseUrl + `/api/GetDispatchedLuggageToReceive`,
  getReceiveReceive: baseUrl + `/api/ReceiptInsertV2`,
  getReceiveInsertAllV2: baseUrl + `/api/ReceiptInsertAllV2`,

  getReceiveSecond: baseUrl + `/api/LITReceipt`,
  getReceiveShortReceive: baseUrl + `/api/Common/ShortReceiptInsertUpdate`,
  getReceiveDataList: baseUrl + `/api/Report/GetRecievedItemsList?`,
  getReceiveLuggageToReceive: baseUrl + `/api/Common/DispatchedLuggageToReceiveLIT?`,

  //dashBoard Url
  getDashBoardDetails: baseUrl + `/api/Report/GetDashboardDetails?`,

  //DashboardPage
  dashBoardCargoNonMovedDetails: baseUrl + `/api/Dashboard/DashBoardCargoNonMovedDetails?`,
  dashboardPreprocessBkgDel: baseUrl + `/api/Dashboard/DashboardPreprocessBkgDel?`,
  dashBoardCargoPartyBreakup: baseUrl + `/api/Dashboard/DashBoardCargoPartyBreakup?`,
  GetCargoKenyaDashBoardData: baseUrl + `/api/Dashboard/GetCargoKenyaDashBoardData?`,
  //lrSearch
  cargoLrStatus: baseUrl + `/api/Common/GetLRStatus?`, //to get Lr status
  //lrdetails for cancel transaction
  LrStatusForCancelTransaction: baseUrl + `/api/Common/GetLRDetailsForTransactionUpdate?`,
  CancelReceiveUpdate: baseUrl + `/api/Common/CancelReceiveUpdate?`,
  CancelBranchReceiveUpdate: baseUrl + `/api/Common/CancelBranchReceiveUpdate?`,
  BookingDetailsUpdate: baseUrl + `/api/Common/BookingDetailsUpdate?`,
  //branchInquiry send sms
  SendBranchInquirySMS: baseUrl + `/api/CargoSendSMS/SendBranchInquirySMS`,
  //maps
  gMapsApiKey: baseUrl + `/api/Common/GetGoogleMapAPIKey?`,
  gMapApi: `https://maps.googleapis.com/maps/api/geocode/json?`,
  setGMapApiKey: baseUrl + `/api/Common/SetGoogleMapAPIKey?`,
  //userList
  getUserList: baseUrl + `/api/Common/UsersListAll`,

  //GSTN
  //validateGSTN:`https://authapi.iamgds.com/ValidateGstinNo?`, //params gstin=23AACCT5096N1ZW
  validateGSTN: baseUrl + `/api/Common/GSTNValidation?`, //params GSTN=23AACCT5096N1ZW

  //Search LR
  getCargoCommonLRData: baseUrl + `/api/common/GetCargoCommonLRData?`,
  cancelBookingByAdmin: baseUrl + `/api/Refund/RefundBookingWeb`,
  //common Lr for admin update
  getCmnLRDataForAdminUpdate: baseUrl + `/api/common/GetLRForAdminUpdate?`,
  //api for modify data
  GetLRForModifyUpdate: baseUrl + `/api/GetLRForModifyUpdate?`,
  //api for get list of rechargeBranch
  GetBranchRechargesListAll: baseUrl + `/api/GetBranchRechargesListAll?`,
  //api for get list of rechargeParty
  PartyRechargesListAllRequest: baseUrl + `/api/PartyRechargesListAllRequest?`,
  //reject recharge api
  //edit branch
  GetBranchRechargeEditRequest: baseUrl + `/api/GetBranchRechargeEditRequest?`,
  //edit party
  GetPartyRechargeEditRequest: baseUrl + `/api/GetPartyRechargeEditRequest?`,
  //waybill format
  StandardPrintFormatList: baseUrl + `/api/Print/StandardPrintFormatListAll`,
  StandardPrintFormatDetails: baseUrl + `/api/Print/CompanyStandardPrintFormatDetails?`,
  CompanyStandardPrintFormatDetailsSave: baseUrl + `/api/Print/CompanyStandardPrintFormatDetailsSave`,

  //accept recharge api
  //accept party recharge
  PartyRechargeConfirmRequest: baseUrl + `/api/PartyRechargeConfirmRequest?`,
  // reject party recharge
  PartyRechargesRejectRequest: baseUrl + `/api/PartyRechargesRejectRequest?`,
  //saveCreditDebitNote
  SetCargoDebitCreditNote: baseUrl + `/api/common/SetCargoDebitCreditNote?`,
  //api for payment mode
  GetRechargePaymentModesListAll: baseUrl + `/api/common/GetRechargePaymentModesListAll?`,
  //Rollback
  LRRollBackUpdate: baseUrl + `/api/common/LRRollBackUpdate?`,
  //MarkAsLost
  MarkAsLost: baseUrl + `/api/common/CargoCommonTransactionInserUpdate?`,
  //SenderReceiverDetailChange
  SenderReceiverDetailChange: baseUrl + `/api/common/SenderReceiverDetailsUpdate?`,
  //Eway Bill update
  EwayBillUpdate: baseUrl + `/api/common/EwayBillUpdateUpdate?`,
  GetExemptedGoodsList: baseUrl + `/api/GeneralSettings/GetExemptedGoodsList?`,
  //booking delivery charge update
  BookingDeliveryDetailsUpdate: baseUrl + `/api/common/BookingDeliveryDetailsUpdate?`,
  //consignment/booking charges update
  ConsignmentBookingChargesUpdate: baseUrl + `/api/GetLRAdditionalChargesEditRequest?`,
  //reports

  getOwnAndChildBranchList: baseUrl + `/api/Common/GetOwnAndChildBranchList?`,
  getOwnAndChildUsersList: baseUrl + `/api/Common/GetOwnAndChildUsersList?`,
  getFranchiseeCompanyList: baseUrl + `/api/Common/CargoGetFranchiseeListAll?`,
  getFranchiseeBranchList: baseUrl + `/api/Common/CargoGetFranchiseeBranchesListAll?`,
  getDispatchReportFilter: baseUrl + `/api/Report/GetDispatchMemoFilters?`,
  getPartyBookingRptFilter: baseUrl + `/api/Common/GetPartyBookingsRptFilter?`,
  getAnalysisReportFilter: baseUrl + `/api/Report/GetBranchAnalysisReportFilter?`,
  getBranchTransferFilter: baseUrl + `/api/Report/GetBranchTransferMemoFilter?`,
  getBranchReceiveFilter: baseUrl + `/api/Report/GetBranchRecieveMemoFilter?`,
  getDispatchDetailsFilter: baseUrl + `/api/Report/DispatchDetail?`,
  getChallanWiseDispatchData: baseUrl + `/api/Report/GetDispatchSummaryRpt?`,
  getDispatchReportSummaryFilter: baseUrl + `/api/Report/DispatchReportSummary?`,
  getDispatchMemoDetailFilter: baseUrl + `/api/Report/DispatchMemoDetail?`,
  getUserWiseCollection: baseUrl + `/api/Report/UserwiseCollectionReport?`,
  getBranchWiseCollectionData: baseUrl + `/api/Report/BranchwiseReport?`,
  getAnalysisDropData: baseUrl + `/api/Report/AnalysisFilterData?`,
  getAnalysisTableData: baseUrl + `/api/Report/AnalysisReport?`,
  getReceivedDropData: baseUrl + `/api/Report/ReceiveReportFilterData?`,
  getReceivedTableData: baseUrl + `/api/Report/ReceiveReport?`,
  getQuikViewTableData: baseUrl + `/api/Report/QuickViewReport?`,

  getOwnBookingReportData: baseUrl + `/api/Report/BookingReport?`,
  BookingFranchiseeReport: baseUrl + `/api/Report/BookingFranchiseeReport?`,
  BookingFilterData: baseUrl + `/api/Report/BookingFilterData?`,
  getOwnBookingFilterData: baseUrl + `/api/Report/BookingFilterData?`,
  getGoodsBalanceFilter: baseUrl + `/api/Report/GoodsBalanceFilter?`,

  getPartyBookingReportFilter: baseUrl + `/api/Report/PartyBookingReportFilter?`,
  getPartyBookingData: baseUrl + `/api/Report/PartyBookingReport?`,
  getBookingFranchiseeData: baseUrl + `/api/Report/BookingFranchiseeReport?`,
  //gstInvoice
  getGstInvoiveData: baseUrl + `/api/Report/GetCargoGSTInvoiceDetails?`,
  //deliveryMemo
  getDeliveryMemoList: baseUrl + `/api/GetDeliveryMemo?`,
  getDeliveryMemoData: baseUrl + `/api/GetLRsForDeliveryMemo?`,
  //onAccount report
  getOnAccountCreditReport: baseUrl + `/api/Report/OnAccountCreditReport?`,
  getBranchTransferData: baseUrl + `/api/Report/BranchTransferReportDetails?`,
  getBranchReceiveData: baseUrl + `/api/Report/BranchReceiveReportDetails?`,

  //Non Movement Report
  getNonMovementFilterData: baseUrl + `/api/Report/NonMovementFilterData?`,
  getCargoNonMovedDetails: baseUrl + `/api/Report/GetCargoNonMovedDetails?`,

  //Booking And Delivery Tracking Report
  getTrackingReportFilter: baseUrl + `/api/Report/TrackingReportFilter?`,
  getTrackingReportData: baseUrl + `/api/Report/TrackingReport?`,

  //Eway Bill Report
  getEwayBookingFilter: baseUrl + `/api/Report/EwaybillReportFilter?`,
  getEwayBookingData: baseUrl + `/api/Report/EwaybillReport?`,

  //Gst Report
  getgstReportFilterData: baseUrl + `/api/Report/GSTReortFilter?`,
  getgstReportDetailData: baseUrl + `/api/Report/GSTReportDetail?`,
  getgstReportSummaryData: baseUrl + `/api/Report/GSTReportSummary?`,
  getGSTReportData: baseUrl + `/api/Report/GSTReport?`,

  //acounting report
  getCompanyStateList: baseUrl + `/api/Common/CompanyStateListAll?`,
  getCargoCompanyGSTList: baseUrl + '/api/Report/CargoCompanyGSTListAll?',
  getGSTReturnSummaryReport: baseUrl + `/api/Report/GSTReturnSummaryReport?`,
  getGSTReturnDetailedReport: baseUrl + `/api/Report/GSTReturnDetailedReport?`,
  //Hisab Report
  getGenerateHisabReport: baseUrl + `/api/Report/GenerateHisabFilter?`,
  getGenerateHisabReportSummary: baseUrl + `/api/Report/GenerateHisabSummary?`,
  getGenerateHisabReportDetailed: baseUrl + `/api/Report/GenerateHisabDetail?`,
  //good balance report
  getgoodBalDropData: baseUrl + `/api/Report/GoodsBalanceFilter?`,
  getGoodBalTableData: baseUrl + `/api/Report/GoodsBalanceReport?`,
  getBranchStockTableData: baseUrl + `/api/Report/BranchStockReport?`,
  getFranchiseOutstandingTableData: baseUrl + `/api/Report/FranchiseeOutStandingReport?`,
  getFranchiseOutstandingTableFiltersData: baseUrl + `/api/Report/FranchiseeOutStandingFilter?`,
  //Credit Report
  getReportBranchList: baseUrl + `/api/Common/GetBranchRightsforReports?`,
  getCreditTransactionData: baseUrl + `/api/Report/CreditTransactionReport?`,
  getCreditUsageData: baseUrl + `/api/Report/CreditUsageReport?`,
  getCreditSummaryData: baseUrl + `/api/Report/CreditSummaryReport?`,
  getCitiesListAll: baseUrl + `/api/Common/CitiesListAll?`,
  saveBranchDetails: baseUrl + '/api/BranchMaster/BranchesInsertUpdate?',
  updateBranchBusData: baseUrl + `/api/BranchMaster/BranchBusConfigUpdate?`,
  updateBranchReportData: baseUrl + `/api/BranchMaster/BranchReportConfigUpdate?`,
  getBranchDirectoryData: baseUrl + `/api/BranchMaster/GetBranchDirectory?`,
  updateBrnhDirectoytData: baseUrl + `/api/BranchMaster/BranchDirectoryUpdate?`,
  getBranchCommission: baseUrl + '/api/BranchMaster/GetBranchCommission?',
  updateBranchCargoConfig: baseUrl + '/api/BranchMaster/BranchCargoConfigUpdate?',
  branchCargoConfigUpdate: baseUrl + '/api/BranchMaster/BranchCargoOtherConfigUpdate?',
  getPartyCreditUsageReport: baseUrl + `/api/Report/PartyCreditUsageReport?`,
  APIOTPBRanchRechargeV2: baseUrl + '/api/Common/APIOTPBRanchRechargeV2',

  //Cargo Unloading Report Urls
  getCargoUnloadingRptTblData: baseUrl + '/api/Report/GetCargoUnloadingReport?',
  getDispVehicleNoData: baseUrl + '/api/Report/GetDispatchedVehicles?',
  // General Setting Urls
  getGSBCreateNewConsType: baseUrl + `/api/GeneralSettings/ConsignmentSubTypeInsertUpdate`,
  getGSPaymentModeTableData: baseUrl + `/api/GeneralSettings/PaymentModeDetails?`,
  getGSPaymentModeSave: baseUrl + `/api/GeneralSettings/PaymentModeDetailsupdate`,
  //PickUp and DropOff
  getPickUpAndDropOff: baseUrl + `/api/GeneralSettings/CargoGetPickupDropoffCharges?`,
  getPickupDropoffChargeSlab: baseUrl + '/api/GeneralSettings/PickupDropoffChargeSlab?',
  updatePickUpAndDropOffCharge: baseUrl + '/api/GeneralSettings/PickupDropoffChargeUpdate?',
  getWeightChrg: baseUrl + `/api/GeneralSettings/WeightChargeList?`,
  updateWeightChrg: baseUrl + `/api/GeneralSettings/WeightChargeInsertUpdate?`,
  //foc approval apis
  getFocApprTblData: baseUrl + `/api/GeneralSettings/CargoGetFoCApproval?`,
  getFocApprAuthInsert: baseUrl + `/api/GeneralSettings/FoCApprovalAuthorityInsert?`,
  //Delivery Charge
  getDeliveryExtraHamaliChargeList: baseUrl + `/api/GeneralSettings/DeliveryExtraHamaliChargeList?`,
  updateDeliveryChrg: baseUrl + `/api/GeneralSettings/DeliveryChargeInsertUpdate?`,
  updateDeliveryExtraHamaliCharge: baseUrl + `/api/GeneralSettings/DeliveryExtraHamaliChargeInsertUpdate`,

  //Hamali Charge
  getHamaliChrgListData: baseUrl + `/api/GeneralSettings/BookingHamaliChargeList?`,
  getBookingOperatorHamaliChargeList: baseUrl + `/api/GeneralSettings/BookingOperatorHamaliChargeList?`,
  updateBookingHamaliChargeInsertUpdate: baseUrl + `/api/GeneralSettings/BookingHamaliChargeInsertUpdate`,
  updateBookingOperatorHamaliChargeInsertUpdate: baseUrl + `/api/GeneralSettings/BookingOperatorHamaliChargeInsertUpdate`,
  //general settings
  //foc approval apis
  getMopInsertUpdate: baseUrl + `/api/GeneralSettings/MOPInsertUpdate?`,

  // General Setting Urls
  getGSDocumentCharges: baseUrl + `/api/GeneralSettings/DocumentChargeList?`,
  getGSDocumentChargeInsertUpdate: baseUrl + `/api/GeneralSettings/DocumentChargeInsertUpdate`,

  //Demurrage Charge >> General Setting
  getDemurrageChrg: baseUrl + `/api/GeneralSettings/DemurrageChargeDetails?`,
  updateDemurrageChrg: baseUrl + `/api/GeneralSettings/DemurrageChargeInsertUpdate?`,
  //luggage cities
  getBranchPaymentTypeConfigUpdate: baseUrl + `/api/GeneralSettings/BranchPaymentTypeConfigUpdate?`,
  getGSBranchValuationDetailsTableData: baseUrl + `/api/GeneralSettings/BranchValuationDetails?`,
  getGSEditValuationDetails: baseUrl + `/api/GeneralSettings/ValuationDetails?`,
  getGSInsuranceInsertUpadate: baseUrl + `/api/GeneralSettings/InsuranceInsertUpdate`,
  //branch and user master urls
  getUserMasterTableData: baseUrl + `/api/Common/UsersListAll`,

  verifyPanNumber: baseUrl + `/api/Common/PanNumberValidation?`,
  getUserRoleRights: baseUrl + `/api/GeneralSettings/RoleList?`,
  addNewUser: baseUrl + `/api/GeneralSettings/UsersInsertUpdate`,
  addNewUserV2: baseUrl + `/api/GeneralSettings/UsersInsertUpdateV2`,
  getEditUser: baseUrl + `/api/GeneralSettings/GetUserDetailsToEdit?`,

  //auto delivery
  getAutoDeliveryTblData: baseUrl + `/api/GeneralSettings/GetAutoDeliveryConfig?`,
  getCompCityList: baseUrl + `/api/GetCompanyCityList?`,
  updateAutoDelivery: baseUrl + `/api/GeneralSettings/AutoDeliveryConfigUpdate?`,
  getWeightChrg: baseUrl + `/api/GeneralSettings/WeightChargeList?`,
  updateWeightChrg: baseUrl + `/api/GeneralSettings/WeightChargeInsertUpdate?`,
  //Delivery Charge >> General Setting
  getDeliveryChrg: baseUrl + `/api/GeneralSettings/DeliveryChargeList?`,
  updateDeliveryChrg: baseUrl + `/api/GeneralSettings/DeliveryChargeInsertUpdate?`,
  //Demurrage Charge >> General Setting
  getDemurrageChrg: baseUrl + `/api/GeneralSettings/DemurrageChargeDetails?`,
  updateDemurrageChrg: baseUrl + `/api/GeneralSettings/DemurrageChargeInsertUpdate?`,
  //Delivery Report
  getDeliveryReportFilterData: baseUrl + `/api/Report/DeliveryReportFilter?`,
  getDeliveryReportTableData: baseUrl + `/api/Report/DeliveryReport?`,
  getFranchiseeDeliveryReportFilterData: baseUrl + `/api/Report/FranchiseDeliveryReportFilter?`,
  getFranchiseeDeliveryReportTableData: baseUrl + `/api/Report/FranchiseDeliveryReport?`,
  //Auto receive apis
  getAutoReceiveTblData: baseUrl + `/api/GeneralSettings/GetAutoReceiveConfig?`,
  getAutoReceiveInsertUpdate: baseUrl + `/api/GeneralSettings/AutoReceiveConfigUpdate?`,
  // Lr Cancel And Penality Report
  getLRPenaltyReportFilterData: baseUrl + `/api/Report/LRPenaltyReportFilter?`,
  getLRPenaltyReportTableData: baseUrl + `/api/Report/LRPenaltyReport?`,

  //weight charge
  // getWeightChrg: baseUrl + `/api/GeneralSettings/WeightChargeList?`,
  //Auto Branch transfer/Branch Receive api
  getAutoTransactionTblData: baseUrl + `/api/GeneralSettings/GetAutoTransactionConfig?`,
  getAutoTransactionInsertUpdate: baseUrl + `/api/GeneralSettings/AutoTransactionConfigUpdate?`,
  getAutoTransactionFilters: baseUrl + `/api/GeneralSettings/AutoTransactionFilterconfig?`,
  //General Settings - Reports - Monthly targate

  getMonthlytargetTableData: baseUrl + `/api/GeneralSettings/MonthlyTarget?`,
  getMonthlyTargetUpdate: baseUrl + `/api/GeneralSettings/MonthlyTargetUpdate?`,

  //GST Invoice config apis
  getGSTInvConfigData: baseUrl + `/api/GeneralSettings/GstInvoiceConfig?`,
  updateGSTInvoiceConfigData: baseUrl + `/api/GeneralSettings/GstInvoiceConfigUpdate?`,
  //branch and user master
  getUserRollRightTblData: baseUrl + `/api/GeneralSettings/RoleList?`,
  getUserRollRightEditRight: baseUrl + `/api/UserRoleRights/RoleRightsListAll?`,
  oTPForUserRoleRightV2: baseUrl + `/api/Common/OTPForUserRoleRightV2?`,
  getUserRREditRightSave: baseUrl + `/api/UserRoleRights/RoleRightsInsertUpdate`,
  getUserRRAddUser: baseUrl + `/api/UserRoleRights/RolesInsertUpdate`,
  getUserRRCashBookRightsSave: baseUrl + `/api/UserRoleRights/CashbookRightsInsertUpdate`,
  getUserRRLuggageBookRightsSave: baseUrl + `/api/UserRoleRights/CargoSpecialRightsInsertUpdate`,
  getUserRRBookAcSpecialRights: baseUrl + `/api/UserRoleRights/RoleRightsConfigListAll?`,
  getUserRRBookAcSpecialRightsSave: baseUrl + `/api/UserRoleRights/BusBookingRightsInsertUpdate`,
  getUserRRARBookAcSpecialRightsSave: baseUrl + `/api/UserRoleRights/AccountingRightsInsertUpdate`,
  getUserRRQTBookAcSpecialRightsSave: baseUrl + `/api/UserRoleRights/QRTransactionRightsInsertUpdate`,
  getUserRRSpecialRightsSave: baseUrl + `/api/UserRoleRights/SpecialRightsInsertUpdate`,
  getGSPaymentModeTableData: baseUrl + `/api/GeneralSettings/PaymentModeDetails?`,
  getGSPaymentModeSave: baseUrl + `/api/GeneralSettings/PaymentModeDetailsupdate`,

  //Auto Deactivate users
  getAutoDeactivateUsersData: baseUrl + `/api/GeneralSettings/RoleList?`,
  updateADUTblData: baseUrl + `/api/GeneralSettings/DeactiveUser?`,
  //branch and user master urls
  getMacRequests: baseUrl + `/api/GeneralSettings/GetMacRequests?`,
  getMacRequestAcceptReject: baseUrl + `/api/GeneralSettings/MacRequestAcceptReject`,
  //Mac Authentication apis
  getMacAuthTableData: baseUrl + `/api/GeneralSettings/GetRegisteredMacforUser?`,
  getMacAuthUpdateAssign: baseUrl + `/api/GeneralSettings/AssignMac?`,
  //Mac Management Apis
  getMacMgmtActiveDeactive: baseUrl + `/api/GeneralSettings/MacActiveDeActive?`,
  //Maven Management apis
  getMavenManagementTableData: baseUrl + `/api/Maven/GetMavenUsers?`,
  updateMavenUsers: baseUrl + `/api/Maven/MavenUsersUpdate`,
  GetBranchMacDetails: baseUrl + `/api/BranchMacAddress/GetBranchMacDetails?`,
  updateBranchMacAddress: baseUrl + `/api/BranchMacAddress/BranchMacAddressUpdate`,
  getBranchCommissionForAll: baseUrl + `/api/BranchMaster/GetBranchCommission?`,

  //Ticket format >>General Setting
  getCargoTicketFormatList: baseUrl + `/api/Print/CargoTicketFormatListAllV2?`,
  getTicketLabelList: baseUrl + `/api/Print/CargoTicketFormatLabelsListALL`,
  getBranchesWithCargoTicketFormat: baseUrl + `/api/Print/BranchesWithCargoTicketFormat?`,
  AssignCargoTicketFormat: baseUrl + `/api/Print/AssignCargoTicketFormat?`,
  updateTicketFormat: baseUrl + `/api/Print/CargoTicketFormatInsertUpdate?`,
  //Bus and carge Memo
  getOnlyBusMemoTrip: baseUrl + `/api/Report/GetOnlyBusMemoTrip?`,
  generateBusMemoVoucherBus: baseUrl + `/api/Report/GenerateBusMemoVoucherBus?`,
  getCargoMemoData: baseUrl + `/api/Report/GenerateCargoMemo?`,
  CargoMemoVoucherUpdate: baseUrl + `/api/Report/CargoMemoVoucherUpdate?`,
  generateCargoMemoVoucherBus: baseUrl + `/api/Report/GetLrsForCargoMemoVoucher?`,
  getBranchRechargeAcceptList: baseUrl + `/api/BranchRechargeAcceptList?`,
  getPartyRechargeList: baseUrl + `/api/PartyRecharge/PartyRechargeList?`,
  getPartyCreditDebitDetails: baseUrl + `/api/PartyRecharge/PartyCreditDebitDetails?`,
  getGetDebitCreditBranch: baseUrl + `/api/GeneralSettings/GetDebitCreditBranch?`,

  getPartyVoucherList: baseUrl + `/api/PartyMaster/GetPartyVoucher?`,
  getPartyVoucherReport: baseUrl + `/api/PartyMaster/GetPartyVoucherReport?`,

  //party master
  getCorporateRateMatrix: baseUrl + `/api/PartyMaster/CorporateRateMatrix?`,
  corporateRateMatrixInsertUpdate: baseUrl + `/api/PartyMaster/CorporateRateMatrixInsertUpdate?`,
  getPartyWeightChrg: baseUrl + `/api/PartyMaster/GetPartyWeightConfig?`,
  updatePartyWeightChrg: baseUrl + `/api/PartyMaster/PartyWeightChargeInsertUpdate?`,

  //Party Master Apis
  getPartyMasterInsertUpdate: baseUrl + `/api/PartyMaster/PartyMasteInsertUpdate?`,
  getPartyRateMatrixData: baseUrl + `/api/PartyMaster/GetPartyRateMatrix?`,
  getPartyRateMatrixUpdate: baseUrl + `/api/PartyMaster/PartyRateUpdate?`,
  getPartyRatesUpload: baseUrl + `/api/PartyMaster/PartyRatesUpload?`,

  //Crossing Master
  GetDestCitiesWithCrossingBranch: baseUrl + `/api/GeneralSettings/GetDestCitiesWithCrossingBranch?`,
  GetCargoDestCitiesWithCrossingBranch: baseUrl + `/api/Common/GetCargoDestCitiesWithCrossingBranch?`,
  CargoUpdateCrossingBranches: baseUrl + `/api/GeneralSettings/CargoUpdateCrossingBranches`,
  CityListForCrossingMaster: baseUrl + `/api/GeneralSettings/CityListForCrossingMaster?`,
  BranchListForCrossingMaster: baseUrl + `/api/GeneralSettings/BranchListForCrossingMaster?`,
  //service type
  ServiceTypeListAllTableData: baseUrl + `/api/GeneralSettings/ServiceTypeListAll?`,
  getServiceTypeInsertUpdate: baseUrl + `/api/GeneralSettings/ServiceTypeInsertUpdate?`,
  //KG-KM Rate matrix apis
  getServiceTypeListAll: baseUrl + `/api/GeneralSettings/ServiceTypeListAll?`,
  kgKmRateMatrixTblData: baseUrl + `/api/GeneralSettings/ConsignmentRateKgKmWiseListAll?`,
  kgKmRateMatrixUpdateTblData: baseUrl + `/api/GeneralSettings/ConsignmentRateKgKmWiseInsertUpdate?`,
  kgKmRatematrixHistoryTblData: baseUrl + `/api/GeneralSettings/ConsignmentRateKgKmHistory?`,
  kgKmRatematrixUploadFile: baseUrl + `/api/DocFile/KGKMFilePost?`,
  kgKmFileUploadStatus: baseUrl + `/api/GeneralSettings/CargoGetKGKMRatemasterUpdateStatus?`,
  kgKmFileUploadCancel: baseUrl + `/api/GeneralSettings/CancelKGKMRateMasterBulkStatus?`,
  getRateMatrixData: baseUrl + '/api/GeneralSettings/RateMatrixData?',
  updateRateMatrixUpdate: baseUrl + '/api/GeneralSettings/RateMatrixUpdate?',
  getPartyMasterListAll: baseUrl + '/api/PartyMaster/PartyMasterListAll?',
  // view rate matrix
  getViewRateMatrixDetails: baseUrl + `/api/GeneralSettings/ViewRateMatrixDetails?`,

  //FTL Booking apis

  GetBookingRates: baseUrl + `/api/GeneralSettings/GetBookingRates?`,
  GetCityDistance: baseUrl + `/api/Common/GetCityDistance?`,

  cityPairRateMatrixData: baseUrl + '/api/GeneralSettings/CityPairRateMatrixData?',
  updateCityPairRate: baseUrl + '/api/GeneralSettings/CityPairRateMatrixUpdate?',
  cityPairRateMatrixExcelData: baseUrl + '/api/GeneralSettings/CityPairRateMatrixAllData?',

  uploadCrossingMasterFile: baseUrl + `/api/DocFile/CrossingMasterFilePost?`,
  uploadCityPairRateFile: baseUrl + '/api/DocFile/Post?',
  cityPairFileUploadStatus: baseUrl + '/api/GeneralSettings/CargoGetRatemasterUpdateStatus?',
  cancelRateMasterStatus: baseUrl + '/api/GeneralSettings/CancelRateMasterBulkStatus?',
  getUserWithTransRightReportTableData: baseUrl + `/api/Report/userWithTransationsRightsReport?`,
  getRechargePenaltyReportData: baseUrl + `/api/Report/RechargePenaltyReport?`,
  getPatyTargetAchivementReportFilterData: baseUrl + `/api/Report/PartyTargetAcheivement_Filter?`,
  getPartyTargetAchivementReportData: baseUrl + `/api/Report/PartyTargetAcheivementListAll?`,
  getPartyCreditLimitTransReportData: baseUrl + `/api/Report/PartyCreditTransactionReport?`,
  getPartyCreditLimitSummaryData: baseUrl + `/api/Report/PartyCreditTransactionSummaryReport?`,
  getLuggageModificationReport: baseUrl + `/api/Report/LuggageModificationReport?`,
  GetLRDetailsForPopUpV2: baseUrl + `/api/Report/GetLRDetailsForPopUpV2?`,
  getToPayDestinationReportData: baseUrl + `/api/Report/ToPayDestinationReport?`,
  getReceiptRegisterReportFilter: baseUrl + `/api/Report/DispatchRegisterReportFilter?`,
  getReceiptRegisterReportTableData: baseUrl + `/api/Report/ReceiptRegistorReport?`,
  DispatchRegisterReportFilter: baseUrl + `/api/Report/DispatchRegisterReportFilter?`,
  DispatchRegisterReport: baseUrl + `/api/Report/DispatchRegisterReport?`,
  DispatchRegisterMemoSummary: baseUrl + `/api/Report/DispatchRegisterMemoSummary`,
  GetDispatchRegistorMemo: baseUrl + `/api/Report/GetDispatchRegistorMemo?`,
  getToPayStatementReport: baseUrl + `/api/Report/ToPayStatementReport?`,
  mpesaTransactionReportData: baseUrl + `/api/Report/MpesaTransactions?`,
  getBranchRechargeListAll: baseUrl + `/api/Report/GetBranchRechargeListAll`,

  //Party voucher - credit voucher tab
  getPartyVoucherCreditData: baseUrl + `/api/PartyMaster/GetPartyCredit?`,
  updatePartyVoucherDiscount: baseUrl + `/api/PartyMaster/PartyDiscountInsertUpdate?`,
  creditReceivePartyVoucherIncertUpdate: baseUrl + `/api/PartyMaster/PartyCreditReceiveInsertUpdate?`,

  //QR Transactions api
  getQRTransactionRpt: baseUrl + `/api/BranchRechargeRequest/LoadQRTranDetails?`,
  getPaySettlementDetail: baseUrl + `/api/BranchRechargeRequest/GetMantisPaySettlementDetails?`,
  getAccDetailInsrtUpdt: baseUrl + `/api/BranchRechargeRequest/MantisPayAccountDetailsInsertUpdate?`,
  getPayTestFundTransfer: baseUrl + `/api/BranchRechargeRequest/SetDQRMantisPayTestFundTransfer?`,

  getBookingInfo: baseUrl + `/api/GeneralSettings/GetBookingInfo?`,
  GetPartyBookingInfo: baseUrl + `/api/GeneralSettings/GetPartyBookingInfo?`,
  GetTripSheetDetails: baseUrl + `/api/Common/FleetopVehicleSheetAsync`,

  //FranchiseePendinfToPay Report
  getFrchseeToPayPending: baseUrl + `/api/Report/FranchiseePendingTopayDataReport?`,
  getFrchseeToPayPendingUpdate: baseUrl + `/api/Report/FranchiseePendingToPayUpdate?`,

  //Franchisee settlement report
  getFrchseeSettlemntReport: baseUrl + `/api/Report/FranchiseeSettlementReport?`,
  getSettlementReportUpdate: baseUrl + `/api/Report/FranchiseeSettlementReportUpdate?`,
  getDispatchMemoView: baseUrl + `/api/Report/DispatchMemoForFranchisee?`,
  //Mpesa
  getPayBillConfig: baseUrl + `/api/Mpesa/GetPayBillConfig`,
  paymentIntiateMpesa: baseUrl + `/api/Mpesa/APICargoPaymentIntiateMpesaV2`,
  confirmValidateMpesaPayment: baseUrl + `/api/Mpesa/APICargoConfirmValidateMpesaPaymentV2`,
  getUnUtilisedPaymentListAll: baseUrl + `/api/Mpesa/CargoGetUnUtilisedPaymentListAll`,
  getCollectionBranchList: baseUrl + `/api/BranchCollection/GetBranchList?`,
  getBranchCollection: baseUrl + `/api/BranchCollection/GetBranchCollection?`,
  branchCollectionUpdate: baseUrl + `/api/BranchCollection/BranchCollectionUpdate`,
  sendCargoSMSDirectBranchWise: baseUrl + `/api/Common/SendCargoSMSDirectBranchWise`,
  getCargoPartyAnalysisData: baseUrl + `/api/Dashboard/GetCargoPartyAnalysisData?`,
  getCargoBranchAnalysisData: baseUrl + `/api/Dashboard/GetCargoBranchAnalysisData?`,
  getCargoBranchCustomerData: baseUrl + `/api/Dashboard/GetCargoBranchCustomerData?`,
  getCargoUserWiseBranchAnalysis: baseUrl + `/api/Dashboard/GetCargoUserWiseBranchAnalysis?`,
  //mtpl master
  getCompaniesListAll: baseUrl + `/api/GetCompaniesListAll`,
  //expense head
  getExpenseEntryDetails: `${baseUrl}/api/Common/GetExpenseEntryDetails`,
  getExpenseHeadDetails: `${baseUrl}/api/GeneralSettings/GetExpenseHeadDetails`,
  getExpenseSubHeadDetails: `${baseUrl}/api/GeneralSettings/GetExpenseSubHeadDetails`,
  expenseEntryUpdate: `${baseUrl}/api/Common/ExpenseEntryUpdate`,
  expenseEntryRemoveUpdate: `${baseUrl}/api/Common/ExpenseEntryRemoveUpdate`,
  expenseEntrySaveUpdate: `${baseUrl}/api/Common/ExpenseEntrySaveUpdate`,
  expenseEntryApprovalUpdate: `${baseUrl}/api/Common/ExpenseEntryApprovalUpdate`,
  userWiseExpenseEntryUpdate: `${baseUrl}/api/Common/UserWiseExpenseEntryUpdate`,
  accountHeadsInsertUpdate: `${baseUrl}/api/GeneralSettings/AccountHeadsInsertUpdate`,
  subAccountHeadsInsertUpdate: `${baseUrl}/api/GeneralSettings/SubAccountHeadsInsertUpdate`,
  getBranchBalanceReport: baseUrl + `/api/Report/BranchBalanceReport`,
  userListForLuggageSettingUpdate: `${baseUrl}/api/Common/GetUserListForLuggageSettingUpdate`,
  OTPForCompanySettingsUpdate: `${baseUrl}/api/Common/OTPForCompanySettingsUpdate`,
  getAllPendingLR: `${baseUrl}/api/OutForDelivery/CargoGetAllPendingLR?`,
  outDeliveryUserInsertUpdate: `${baseUrl}/api/OutForDelivery/CargoOutDeliveryUserInsertUpdate`,
  getAllPendingLRsForOutDelivery: `${baseUrl}/api/OutForDelivery/CargoGetAllPendingLRsForOutDelivery?`,
  getOutForDeliveryDetails: `${baseUrl}/api/OutForDelivery/CargoGetOutForDeliveryDetails?`,
  getAuthenticationToken: baseUrl + `/api/Common/GetAuthenticationToken?`,
  getCargoPickupDropoffCartage: `${baseUrl}/api/GeneralSettings/CargoGetPickupDropoffCartage?`,
  pickupDropoffCartageUpdate: `${baseUrl}/api/GeneralSettings/PickupDropoffCartageUpdate`,
  pickupDropoffCartageSlab: `${baseUrl}/api/GeneralSettings/PickupDropoffCartageSlab?`,
  bookingTrackingStatus: `${baseUrl}/api/Report/BookingTrackingStatus`,
  getChildCompanyListAll: `${baseUrl}/api/Common/ChildCompanyListAll`,
  getDispacthedCities: `${baseUrl}/api/Common/GetDispacthedCities?`,
  getBranchDueReportFilterData: `${baseUrl}/api/Report/BranchDueReportFilterData?`,
  getBranchDueReportData: `${baseUrl}/api/Report/BranchDueReportData?`,
  getBranchDueReportDetailedData: `${baseUrl}/api/Report/BranchDueReportDetailedData?`,
  branchDueAmountUpdate: `${baseUrl}/api/Report/BranchDueAmountUpdate`,
  bookingSummaryPreprocessData: `${baseUrl}/api/Report/BookingSummaryPreprocessData?`,
  getExpenseHeaderMaster: `${baseUrl}/api/Report/GetExpenseHeaderMaster?`,
  expenseHeaderInsertUpdate: `${baseUrl}/api/Report/ExpenseHeaderInsertUpdate`,
  getBranchExpenseDetails: `${baseUrl}/api/Report/GetBranchExpenseDetails?`,
  branchExpensePaymentUpdate: `${baseUrl}/api/Report/BranchExpensePaymentUpdate`,
  getProfitAndLossReportFilter: `${baseUrl}/api/Report/GetProfitAndLossReportFilter?`,
  getProfitAndLossReport: `${baseUrl}/api/Report/GetProfitAndLossReport?`,
  getBranchTransferCities: `${baseUrl}/api/Common/GetBranchTransferCities?`,
  getCargoRoutes: `${baseUrl}/api/GeneralSettings/GetCargoRoutes?`,
  getCargoPartywiseConsignmentTypes: `${baseUrl}/api/GeneralSettings/GetCargoPartywiseConsignmentTypes?`,
  cargoPartywiseConsignmentTypesUpdate: `${baseUrl}/api/GeneralSettings/CargoPartywiseConsignmentTypesUpdate`,
  cargoRoutesInsertUpdate: `${baseUrl}/api/GeneralSettings/CargoRoutesInsertUpdate`,
  getSMSBookingPolicies: `${baseUrl}/api/SMSPolicy/GetSMSBookingPolicies?`,
  cargoSMSPoliciesUpdate: `${baseUrl}/api/SMSPolicy/CargoSMSPoliciesUpdate`,
  cargoSMSTemplateUpdate: `${baseUrl}/api/SMSPolicy/CargoSMSTemplateUpdate`,
  sendSMSOTPForSMSPolicies: `${baseUrl}/api/SMSPolicy/SendSMSOTPForSMSPolicies?`,
  generateOTPForSMSLock: `${baseUrl}/api/SMSPolicy/GenerateOTPForSMSLock`,
  verifyOTPForSMSLock: `${baseUrl}/api/SMSPolicy/VerifyOTPForSMSLock?`,
}

export const booking = 'Booking'
export const bookingOffline = 'Offline Booking'
export const delivery = 'Delivery'
export const branchTransfer = 'Branch Transfer'
export const branchTransferReceive = 'Branch Transfer Receive'
export const receive = 'Receive'
export const alert = 'Alert'
export const dispatchCargo = 'Dispatch'
export const deliveryV2Cargo = 'Only Delivery'

export const reports = 'Reports'
export const admin = 'Admin Privilege'
export const selectUser = 'Select User'
export const recharge = 'Accounts Privilege'
export const operationsPrivilege = 'Expense Entry & Approval'
export const generalSettings = 'General Settings'
export const BrchUsrMaster = 'Branch & User Master'
export const deliveryMemo = 'Delivery Memo'
export const acountingReports = 'Acounting Reports'
export const BookingEnable = 'Branch Enable'
export const NotLogin = 'Not Able To Login'
export const dashBoard = 'Dashboard'
export const updateOutDelivery = 'Update Out Delivery'
export const pendingOutDelivery = 'Pending Out Delivery'
export const outDeliveryStatus = 'Out For Delivery Status'
export const businessAnalysis = 'Business Analysis'
export const mtplMaster = 'mtplMaster'
export const actvtyOpts = [
  { id: 1, value: booking },
  { id: 1, value: bookingOffline },
  { id: 8, value: branchTransfer },
  { id: 9, value: branchTransferReceive },
  { id: 3, value: dispatchCargo },
  { id: 4, value: receive },
  { id: 6, value: delivery },
  { id: 6, value: deliveryV2Cargo },
  { id: 100, value: reports },
  { id: 102, value: admin },
  { id: 20, value: recharge },
  { id: 19, value: operationsPrivilege },
  { id: 300, value: deliveryMemo },
  { id: 301, value: generalSettings },
  { id: 104, value: acountingReports },
  { id: 105, value: BrchUsrMaster },
  { id: 106, value: dashBoard },
  { id: 107, value: businessAnalysis },
  { id: 200, value: mtplMaster },
]

export const MM = 'MM'
export const CM = 'CM'
export const INCH = 'INCH'
export const FEET = 'FEET'
export const METER = 'METER'

export const Length = 'Length'
export const Width = 'Width'
export const Height = 'Height'

export const Pickup = 'Pickup'
export const Commission = 'Miscellnious'
export const Return = 'DropOff'

export const WtVlmUnitArr = [
  { unitLabel: FEET, devisor: 0.176573, devisor2: 0.1428571 },
  { unitLabel: INCH, devisor: 305.1181, devisor2: 246.857 },
  { unitLabel: CM, devisor: 5000, devisor2: 4045.264 },
  { unitLabel: METER, devisor: 0.005, devisor2: 0.0040453 },
  { unitLabel: MM, devisor: 5000000, devisor2: 4045263.799 },
]
export const WtVlmKeyArr = [
  { id: `wt_vlm_len`, lbl: Length, nextID: `wt_vlm_wid`, prevID: 'idForWeightActual0' },
  { id: `wt_vlm_wid`, lbl: Width, nextID: `wt_vlm_ht`, prevID: `wt_vlm_len` },
  { id: `wt_vlm_ht`, lbl: Height, nextID: 'saveVolumetricvol', prevID: `wt_vlm_wid` },
]
export const collCartageBrkupKeyArr = [
  { id: `CCBrkup_pckp`, lbl: Pickup, nextID: `CCBrkup_cmsn`, prevID: `idForAddOrRemoveBtton0` },
  { id: `CCBrkup_cmsn`, lbl: Commission, nextID: `saveCartageBreakupButton`, prevID: `CCBrkup_pckp` },
  // { id: `CCBrkup_rtrn`, lbl: Return, nextID: `saveCartageBreakupButton`, prevID: `CCBrkup_cmsn` },
]

export const CCRlblTxt = `Cartage Remark`

export const GSTPayerInfo = [
  { stpId: 1, srvcTaxPayerCode: `'`, srvcTaxPayer: 'None' },
  { stpId: 2, srvcTaxPayerCode: `Tr`, srvcTaxPayer: 'Transporter', isDefault: true },
  { stpId: 3, srvcTaxPayerCode: `Cr`, srvcTaxPayer: 'Consigner' },
  { stpId: 4, srvcTaxPayerCode: `Cn`, srvcTaxPayer: 'Consignee' },
]

export const paymentMode = [
  { modeId: 1, Mode: 'Cash' },
  { modeId: 2, Mode: 'Credit' },
]
export const deliveryType = [
  { delTypeId: 1, delType: 'GoDown' },
  { delTypeId: 1, delType: 'Home' },
]

export const PaymentTypes = [
  { paymntTypeId: 1, paymntTypeName: 'PAID' },
  { paymntTypeId: 2, paymntTypeName: 'TOPAY' },
  { paymntTypeId: 3, paymntTypeName: 'FOC' },
  { paymntTypeId: 4, paymntTypeName: 'COD' },
  { paymntTypeId: 5, paymntTypeName: 'ONACCOUNT' },
  { paymntTypeId: 6, paymntTypeName: 'PAID(MANUAL)' },
  { paymntTypeId: 7, paymntTypeName: 'TOPAY(MANUAL)' },
  { paymntTypeId: 8, paymntTypeName: 'SELF' },
  { paymntTypeId: 9, paymntTypeName: 'ToPayDDDV' },
  { paymntTypeId: 10, paymntTypeName: 'ONACCOUNT(MANUAL)' },
]
export const apiPaymentTypes = [null, 'PAID', 'TOPAY', 'FOC', 'COD', 'OnAcc', 'PaidMan', 'TopayMan', 'Self', 'ToPayDDDV', 'OnAccMan']
export const TransactionType = [
  { transactionTypeId: 1, transactionTypeName: 'Booking' },
  { transactionTypeId: 2, transactionTypeName: 'Delivery' },
  { transactionTypeId: 3, transactionTypeName: 'Refund' },
]
export const Aws_S3_Bucket_info = {
  name: 'crs-cargo-proof',
  region: 'ap-southeast-1',
  AWSProfileName: 'profile1',
  AWSAccessKey: 'AKIAIH33XTFU3K5MRLTA',
  AWSSecretKey: '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',
}

// keys

export const SEARCH_ACTIVITY = 'search_activity'
export const SEL_STARTING_CITY = 'sel_starting_city'
export const SEL_STARTING_BRANCH = 'sel_starting_branch'
export const SEL_DESTINATION_CITY = 'sel_destination_city'
export const SEL_DESTINATION_BRANCH = 'sel_destination_branch'
export const SEL_BOOKING_TYPE = 'sel_booking_type'
export const SEL_PAYMENT_TYPES = 'sel_payment_type'
export const SEL_SEARCH_BY = 'sel_search_by'

export const SELECT_CONSIGNER = 'select_consigner'
export const SELECT_CONSIGNEE = 'select_consignee'

export const SEL_CONSIGNMENT_TYPE = 'sel_consignment_type'
export const GET_ID_PROOF = 'GET_ID_PROOF'

export const SEL_METHOD_OF_PACKING = 'sel_method_of_packing'

export const SELECT = '- Select -'
export const DROPOFF_MODE = 2
export const PICKUP_MODE = 1
export const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/

export const consignmentTypeAll = {
  ConsignmentSubTypeID: 0,
  CompanyID: 1,
  SubType: 'All',
  BillingUnit: 0,
  MeasurementUnit: 0,
  MinWeightPerUnit: 0,
  MultiplesOfWeight: 0,
  Remarks: '',
  IsActive: 1,
  IsDeleted: 0,
  Rate: 0,
  MinChargeWeight: 0,
  DefaultMOPId: 0,
  IsMOPEditable: 0,
  MinWeightAllUnits: 0,
  IsVolumetricWeight: 0,
  HasStax: 0,
  IsKgKm: 0,
}
export const dispatchDateModes = ['All', 'Monthly', 'Date']
export const vehicleTypeList = ['SV', 'HV'] //special vehicle ,hired vehicle
export const monthList = () => {
  var d = new Date()
  d.setDate(1)
  let monthData = []
  for (let i = 0; i <= 11; i++) {
    monthData.push({ monthName: monthNameFull[d.getMonth()] + ' ' + d.getFullYear(), monthVal: d.getMonth(), yearVal: d.getFullYear() })
    d.setMonth(d.getMonth() - 1)
  }
  return monthData
}
// from city payment enabled
// to city payment enabled
// user role rights payment enabled

// cmpny sett IsManual and ( To Pay, Paid) --> Add To Pay Manual, Paid Manual
// ''          IsOnAccount & on Acc && Is Manual --> Add on Acc Manual

// cmnt city list all
// IsFromTo
// 1 : from city
// 2 : to city
// if DisplayOnlyDispatchcities from cargo setting is 1 then isFromTo=44
// if company id = 11 or from GetOwnParentCompany api ParentCompanyID = 10 then isFromTo=22

// min Tax amt => 0 --> def value transporter
// min Tax amt > 0, payment type : PAID 1, PAId Manual 6, On ACC 5 ,On ACC Manual 10 & if its sender valid gstin then consignor
// min Tax amt > 0, payment type : To Pay 2, 7 To Pay Manual, 4 COD & if its receiver valid gstin then consignee
// FOC 3 always free of cost --> 0 `None` ??

// gst paid by is not required in receiver side ?? confirm

// ph no --> primary
// mob no --> 2nd no
// GSTN

//jpg, jpeg, png, pdf (onhold) --> valid formats

// inch 1
// cm 0
// mm 2

// IsVolumetricWeight: `to show`
// Big Box, carton

// Weight(Actual), consgnmnt Type, bkgType, cnsgnr Chk?, sender party Id: 0

//ISMoP --.

//In

// unit --> number type

// IS STA cmpny --> Wt Charge --> readOnly

// wt charge = unit * minWtCharge

// Weight charge calculation:

// int intQty = Convert.ToInt32(radGridConsignItems.Rows[ele.RowIndex].Cells["Unit"].Value); // Convert.ToInt32(e.Row.Cells["Unit"].Value.ToString());

// int intActWeight = Convert.ToInt32(radGridConsignItems.Rows[ele.RowIndex].Cells["ActualWeight"].Value);

// int intMinAllUnitChargeWeight = Convert.ToInt32(radGridConsignItems.Rows[ele.RowIndex].Cells["MinWeightAllUnits"].Value);
// int intMinPerUnitChargeWeight = Convert.ToInt32(radGridConsignItems.Rows[ele.RowIndex].Cells["MinWeightPerUnit"].Value);

// int intCalChrgWeight = 0;

// if (intMinPerUnitChargeWeight > 0)
//     intCalChrgWeight = intQty * intMinPerUnitChargeWeight;
// else
//     intCalChrgWeight = intMinAllUnitChargeWeight;

// if (intCalChrgWeight < intActWeight)
// {
//     radGridConsignItems.Rows[ele.RowIndex].Cells["WeightChrg"].Value = intActWeight;
// }
// else
// {
//     radGridConsignItems.Rows[ele.RowIndex].Cells["WeightChrg"].Value = intCalChrgWeight;
// }

// Freight
// box - billing unit= 2 unit *rate
// vegetable - billing unit= 1 weightcrg *rate
export const branchObj = {
  AccSysLedgerName: '',
  Address: 'All',
  BranchCode: 'All',
  BranchID: 0,
  BranchManagerName: 'All',
  BranchName: 'All',
  BranchNo: 0,
  BranchTypeID: 0,
  BusCommPct: 0,
  CargoAllowToPayBooking: 1,
  CargoCommPct: 0,
  CargoFranchiseeName: '',
  CargoFranchiseeName1: '',
  CargoHasBooking_GT: 0,
  CargoHasCrossing: 1,
  CargoHasDelivery: 1,
  CargoHasDeliveryManual: 1,
  CargoHasDelivery_GT: 0,
  CargoHasLaserPrinter: 0,
  CargoHasSTax: 1,
  CargoHasSTaxOfflineBooking: 1,
  CargoIncludeInAllBranchesRpt: 1,
  CargoIsVisible_GT: 0,
  CargoTicketFormatID: 0,
  CityID: 0,
  CompanyID: 1,
  ContactNo1: '123',
  ContactNo2: '',
  EWBApiPwd: '',
  EWBApiUserId: '',
  EWBTransporterId: '',
  EmailID: '',
  EwbPwd: '',
  EwbUserId: '',
  GSTN: '',
  IsActive: 1,
  IsCargoCreditLimit: 0,
  IsFranchise: 0,
  IsFranchiseVoucherGenerationEnabled: 0,
  IsIncludeBookingInMemo: 1,
  IsOnline: 0,
  IsOwnChildCompany: 0,
  IsOwnChildCompanyDel_GT: 0,
  IsQuotaBranch: 0,
  IsSharedChildCompany: 0,
  SharedWithCompanyID: null,
  StateID: 5,
  StateName: 'All',
  TicketFormatID: 0,
  TicketFormatIDCancel: 0,
  TicketFormatOfflineID: 0,
}
export const cityObj = {
  CityID: 0,
  CityName: 'All',
  StateID: 0,
  StateName: 'All',
  GoogleLatitude: 0,
  GoogleLongitude: 0,
  CityShortName: 'All',
  CitiHasCargoDelivery: '1',
}
export const Consignmentobj = {
  BillingUnit: 0,
  CompanyID: 1,
  ConsignmentSubTypeID: 0,
  DefaultMOPId: 0,
  HasStax: 0,
  IsActive: 0,
  IsDeleted: 0,
  IsKgKm: 0,
  IsMOPEditable: 0,
  IsVolumetricWeight: 0,
  MeasurementUnit: 0,
  MinChargeWeight: 0,
  MinWeightAllUnits: 0,
  MinWeightPerUnit: 0,
  MultiplesOfWeight: 0,
  Rate: 0,
  Remarks: '',
  SubType: 'All',
}

export const userAll = {
  UserName: 'All',
  UserID: 0,
}
export const branchAll = {
  BranchName: 'All',
  BranchID: 0,
}
export const nameAll = { id: 0, name: 'All' }

export const reportTypeDispatchFilter = [
  { id: 0, Name: 'Dispatch' },
  { id: 1, Name: 'Cancel Dispatch' },
]
export const reportViewDispatchFilter = [
  { id: 0, Name: 'Summary' },
  { id: 1, Name: 'Detailed' },
]
export const reportOptionsDetailedViewDispatchFilter = [
  { id: 0, Name: 'Vehicle wise Dispatch' },
  { id: 1, Name: 'With Vehicle and Chart Date' },
  { id: 2, Name: 'With Payment Type Group' },
  { id: 3, Name: 'Show Only ToPay Amount' },
  { id: 4, Name: 'Vehicle and Tripwise Dispatch' },
]
export const reportOptionsSummaryViewDispatchFilter = [
  { id: 0, Name: 'With Vehicle and Chart Date' },
  { id: 1, Name: 'With Hamali and Cartage' },
  { id: 2, Name: 'With Other Charges' },
  { id: 3, Name: 'Branch Summary' },
  { id: 4, Name: 'Vehicle Wise Dispatch' },
  { id: 5, Name: 'Challan Wise Dispatch' },
  { id: 6, Name: 'Other Charges' },
]
export const vahicleAll = {
  userName: 'ALL',
  id: 0,
}
export const allDestinationCity = {
  userName: 'ALL',
  id: 0,
}
export const allDestinationBranch = {
  userName: 'ALL',
  id: 0,
}
export const nmrStatus = [
  { id: 0, StatusCode: 'All', Name: '--All--' },
  { id: 1, StatusCode: 'B', Name: 'Booked But Pending Dispatch' },
  { id: 2, StatusCode: 'D', Name: 'Dispatched But Pending Receive' },
  { id: 3, StatusCode: 'DR', Name: 'Received But Pending Delivery' },
]
export const paymentModeAll = {
  ModeName: 'All',
  ModeID: 0,
}

export const summaryFitlerDispatch = [
  { id: 0, Name: 'Branch' },
  { id: 1, Name: 'Vehicle and Date' },
  { id: 2, Name: 'Without Vehicle Group' },
  { id: 3, Name: 'With Hamali and Cartage' },
  { id: 4, Name: 'With All Charges' },
  { id: 5, Name: 'Cancelled Dispatch' },
]
export const PaymentTypesOptions = [
  { id: 0, Name: 'ALL' },
  { id: 1, Name: 'PAID' },
  { id: 6, Name: 'Paid Manual' },
  { id: 2, Name: 'ToPay' },
  { id: 7, Name: 'ToPay Manual' },
  { id: 9, Name: 'ToPay DDDV' },
  { id: 5, Name: 'On-Account' },
  { id: 10, Name: 'On-Account Manual' },
  { id: 8, Name: 'Self Booking' },
  { id: 4, Name: 'COD' },
  { id: 3, Name: 'FOC' },
]
export const TransactionTypeOption = [
  { id: 'All', Name: 'ALL' },
  { id: 'B', Name: 'Booking' },
  { id: 'D', Name: 'Delivery' },
  { id: 'R', Name: 'Refund' },
]

export const detailedFitlerDispatch = [
  { id: 0, Name: 'Branch' },
  { id: 1, Name: 'Vehicle and Date' },
  { id: 2, Name: 'Without Vehicle Group' },
  { id: 3, Name: 'With Hamali and Cartage' },
  { id: 4, Name: 'With All Charges' },
  { id: 5, Name: 'Cancelled Dispatch' },
]
export const nmrSummary = [
  { id: 0, Name: ' Summary' },
  { id: 1, Name: 'Branch Summary' },
  { id: 2, Name: 'Include Crossing Summary' },
]
export const xlCol = { dataType: 'string', dataFormatter: null }
export const xlColq = { dataType: 'quantity', dataFormatter: null }
export const nmrDays = ['0', 1, 2, 3, 4, 5, 6, 7]
export const PARENT_COMPANY_MODE = 3
export const mainTabIds = (index) => {
  return {
    id: `main-tab-${index}`,
    'aria-controls': `main-tabpanel-${index}`,
  }
}
export const pcTabIds = (index) => {
  return {
    id: `pc-tab-${index}`,
    'aria-controls': `pc-tabpanel-${index}`,
  }
}
export const paymentTypeColor = [
  { color: '#d1f5d3', value: 'Paid' },
  { color: '#e2e3f3', value: 'ON Acount' },
  { color: '#ffe0bd', value: 'To Pay' },
  { color: '#c3f8ff', value: 'Self' },
  { color: '#ffd8e5', value: 'COD' },
  { color: '#BDE1E1', value: 'FOC' },
  { color: '#fffdaf', value: 'ToPay(DDDV)' },
]

export const reportView = [
  { ReportView: 'Summary', ReportId: '0' },
  { ReportView: 'Detailed', ReportId: '1' },
]
export const userList = [{ UserName: 'All', UserID: '0' }]
export const transType = [
  { TransType: 'All Txns.', TransId: 0 },
  { TransType: 'Booked Txns.', TransId: 1 },
  { TransType: 'Refund Txns.', TransId: 2 },
]
export const lrStatusView = [
  { LrStatus: 'All Status', LrId: '0' },
  { LrStatus: 'Booked But Pending Dispatch', LrId: '1' },
  { LrStatus: 'Dispatched But Pending Receive', LrId: '2' },
  // { LrStatus: 'Received But Pending Dispatch', LrId: '3' },
  { LrStatus: 'Received But Pending Delivery', LrId: '4' },
]
export const lrStatusView1 = [
  { LrStatus: 'All Status', LrId: '0' },
  { LrStatus: 'Booked But Pending Dispatch', LrId: '1' },
  { LrStatus: 'Dispatched But Pending Receive', LrId: '2' },
  { LrStatus: 'Received But Pending Dispatch', LrId: '3' },
  { LrStatus: 'Received But Pending Delivery', LrId: '4' },
]
export const noImageUrl =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/256px-No-Image-Placeholder.svg.png'

export const reportViewOpt = [
  { id: 0, name: 'Summary' },
  { id: 1, name: 'Detailed' },
]
export const showTransaction = [
  { id: 0, name: 'Booking Date Wise' },
  { id: 1, name: 'Transaction Date Wise' },
]
export const includingCrossing = [
  { id: 'All', name: '--All--' },
  { id: 'B', name: 'Booked but pending dispatch' },
  { id: 'D', name: 'Dispatched but pending receive' },
  { id: 'DR', name: 'Received but pending delivery' },
  { id: 'R', name: 'Received but pending Dispatch' },
  { id: 'BR', name: 'Booked & Received But Pending Dispatch' },
]
export const excludingCrossing = [
  { id: 'All', name: '--All--' },
  { id: 'B', name: 'Booked but pending dispatch' },
  { id: 'D', name: 'Dispatched but pending receive' },
  { id: 'DR', name: 'Received but pending delivery' },
]
export const crossingTransactions = [
  { id: 1, name: 'Including Crossing' },
  { id: 2, name: 'Excluding Crossing' },
]
export const summaryReport = [
  { id: 1, name: 'Payment Type Wise' },
  { id: 2, name: 'Branch Wise Summary' },
  { id: 3, name: 'Status Wise Summary' },
]
export const detailedReport = [{ id: 1, name: 'LR Wise Detailed Status' }]

export const MovementReportView = [
  { id: 0, name: 'Summary' },
  { id: 1, name: 'Detailed' },
]

export const allReports = [
  { name: 'Daily Branch Collection', JobID: 470, reportNo: 1 }, //v2
  { name: 'Booking Report', JobID: 465, reportNo: 2 }, //v2
  { name: 'Dispatch Report', JobID: 457, reportNo: 3 }, //v2
  { name: 'Receive Report', JobID: 461, reportNo: 4 }, //v2
  { name: 'Delivery Report', JobID: 467, reportNo: 5 }, //v2
  { name: 'Refund Report', JobID: 549, reportNo: 19 }, //v2
  { name: 'Branch Transfer', JobID: 462, reportNo: 6 }, //v2
  { name: 'Branch Transfer Received', JobID: 463, reportNo: 7 }, //v2
  { name: 'On-Account Credit', JobID: 484, reportNo: 8 }, //v2
  { name: 'Analysis Report', JobID: 90, reportNo: 9 }, //v1
  { name: 'Nonmovement Report', JobID: 486, reportNo: 10 }, //v1
  { name: 'Quick View Report', JobID: 479, reportNo: 11 }, //v3
  { name: 'Eway Bills Report', JobID: 483, reportNo: 12 }, //v2
  { name: 'Party Booking Report', JobID: 485, reportNo: 13 }, //v2
  { name: 'User Wise Collection Report', JobID: 62, reportNo: 14 }, //v1
  { name: 'Goods Balance Report', JobID: 190, reportNo: 15 }, //v1
  { name: 'Booking And Delivery Tracking', JobID: 193, reportNo: 16 }, //v1
  { name: 'Cargo Unloading Report', JobID: 197, reportNo: 17 }, //v1
  { name: 'LR Cancel Penalty Report', JobID: 19, reportNo: 18 }, //v1
  { name: 'User With Transaction Right Report', JobID: 552, reportNo: 20 }, //v1
  { name: 'Party Business Report', JobID: 550, reportNo: 21 }, //v1
  { name: 'Failed Transactions Penalty Report', JobID: 551, reportNo: 22 }, //v1//551
  { name: 'Luggage Modification Report', JobID: 349, reportNo: 51 },
  { name: 'Branch Stock Report', JobID: 69, reportNo: 23 }, //v1//551
  { name: 'To Pay Destination Report', JobID: 195, reportNo: 24 }, //v1//551
  // { name: 'Receipt Register', JobID: 552, reportNo: 23 }, //v1//551
  { name: 'Franchise Outstanding', JobID: 558, reportNo: 25 }, //v1//551
  { name: 'Receipt Register', JobID: 552, reportNo: 26 }, //v1//551
  { name: 'Dispatch Register', JobID: 149, reportNo: 100 }, //v2
  { name: 'To-Pay Statement Report', JobID: 551, reportNo: 30 }, //v1//551
  { name: 'User Wise Collection with Expense', JobID: 566, reportNo: 31 }, //v1//551
  { name: 'Branch Balance Report', JobID: 569, reportNo: 32 }, //v1//551
  { name: 'Recharge History Report', JobID: 570, reportNo: 33 }, //v1//551
]
export const selectPaymentModeOpt = [
  { id: 1, name: 'Cheque' },
  { id: 2, name: 'Demand Draft' },
  { id: 3, name: 'Net Banking' },
  { id: 4, name: 'UPI - QR Scan' },
]

export const BranchRechargePendingCol = [
  { headerName: 'S/N', field: 'sNo', headerSx: { textAlign: 'right', minWidth: '60px' } },
  { headerName: 'Branch Name', field: 'branchName', headerSx: { textAlign: 'left', minWidth: '293px' } },
  { headerName: 'Recharge Date-Time', field: 'RechargeDateTime', headerSx: { textAlign: 'left', minWidth: '139px' } },
  { headerName: 'Payment Mode', field: 'PaymentMode', headerSx: { textAlign: 'left', minWidth: '169px' } },
  { headerName: 'Recharge Amount', field: 'rechargeAmount', headerSx: { textAlign: 'right', minWidth: '169px' } },
  { headerName: 'Requested By', field: 'requestedBy', headerSx: { textAlign: 'left', minWidth: '169px' } },
  { headerName: 'Show OR', field: 'ShowOR', headerSx: { textAlign: 'left', minWidth: '169px' } },
]
